import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getCampaignDescription } from '../../redux/modules/campaignLandingPage';
import styles from './CampaignDescription.module.less';

const CampaignDescription = ({
  campaignDescription,
}) => {
  return (
    <section className={styles.vpDescriptionContainer}>
      {campaignDescription}
    </section>
  );
};

CampaignDescription.propTypes = {
  campaignDescription: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    campaignDescription: getCampaignDescription(state),
  };
}

export default connect(mapStateToProps)(CampaignDescription);



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/CampaignDescription.jsx